import {faChevronsRight} from "@fortawesome/pro-solid-svg-icons/faChevronsRight";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {ErrorMessage} from "@hookform/error-message";
import {ComboBoxControl, ValidationError} from "@twigsby/frontend-framework";
import {useFormContext} from "@twigsby/frontend-framework/lib/ReactHookForm";
import React, {useState} from "react";
import {RulesetActionEntry} from "./RulesetActionEntry";

export type RulesetActionType = {
    name: string;
}

const ThingActionList = [
    { label: 'Apply Tag', value: 0 },
    { label: 'Remove Tag', value: 1 },
    { label: 'Add to Folder', value: 2 },
    { label: 'Remove from Folder', value: 3 },
    { label: 'Add to Cloud Drive', value: 4 },
    { label: 'Perform Action', value: 5 },
    { label: 'Forward', value: 6 },
]

const RulesetAction = (props: RulesetActionType) => {
    const { getFieldState, getValues, setValue, formState } = useFormContext();

    const [ currentAction, setCurrentAction] = useState<any>(-1);

    console.log('action', getFieldState(props.name), formState.errors);

    return (
        <>
            <div className={`thing-action ${getFieldState(props.name).invalid ? 'invalid' : ''}`}>
                <ComboBoxControl
                    name={`${props.name}.id`}
                    placeholder={'Select Action...'}
                    data={ThingActionList}
                    defaultValues={getValues(`${props.name}.id`) ? [getValues(`${props.name}.id`)] : undefined}
                    valueType={'number'}
                    singleSelection={true}
                    forwardValueCallback={(val) => {
                        setCurrentAction(val);
                        setValue(`${props.name}.id`, val)
                    }}
                />

                <div className={'thing-icon'}>
                    {currentAction > -1 && (
                        <FontAwesomeIcon icon={faChevronsRight} fixedWidth={true} className={'hidden'} />
                    )}
                </div>

                <RulesetActionEntry name={props.name} actionId={currentAction}  />

                <ErrorMessage
                    errors={formState.errors}
                    name={`${props.name}.id`}
                    render={({ message }) => <ValidationError value={message} />}
                />
            </div>
        </>
    )
}

export { RulesetAction }
